// import Modal from '@axa-japan/design-system-react/Modal';
import StatusModal from '@axa-japan/design-system-react/StatusModal';

import Button from '@axa-japan/design-system-react/Button';
import Modal from '@axa-japan/design-system-react/Modal';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SEARCH_PARAMS_INTERNAL } from '../../constants/auth';
import { ACTIVE_STEP } from '../../pages/HomePage';
import { useUserContext } from '../../providers/UserProvider';
import { AUTH_TYPE } from '../../types/auth';
import { DOCUMENT_UPLOAD_PROGRESS } from '../../types/session';

type CloseButtonProps = {
  currentStep: string;
};

const CloseButton: React.FC<CloseButtonProps> = ({ currentStep }) => {
  const navigate = useNavigate();
  const { uploadStatus, connectionType } = useUserContext();

  const showGenericModal =
    currentStep === ACTIVE_STEP.agreementPage ||
    currentStep === ACTIVE_STEP.documentFormSelection ||
    uploadStatus !== DOCUMENT_UPLOAD_PROGRESS.inProgress;

  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const handleCloseButton = () => {
    setIsWarningModalOpen(true);
  };

  const handleSubmitButton = () => {
    navigate(`/exit${connectionType === AUTH_TYPE.Internal ? `?${SEARCH_PARAMS_INTERNAL}=${AUTH_TYPE.Internal}` : ''}`);
  };

  return (
    <div className="mx-auto mt-10 text-center">
      {showGenericModal ? (
        <Modal
          id="default-modal"
          open={isWarningModalOpen}
          setOpen={setIsWarningModalOpen}
          title="画面を閉じて終了します"
          content="OKボタンを押して終了してください。"
          buttons={[
            {
              text: 'OK',
              onClick: handleSubmitButton,
            },
            {
              text: 'キャンセル',
              onClick: () => setIsWarningModalOpen(false),
            },
          ]}
        />
      ) : (
        <StatusModal
          id="status-modal-with-two-button"
          open={isWarningModalOpen}
          setOpen={setIsWarningModalOpen}
          title="画面を閉じて終了します"
          content="まだ手続きは済んでいません。未送信の撮影または選択いただいたファイルがすべて削除されますがよろしいでしょうか。"
          buttons={[
            {
              text: 'キャンセル',
            },
            {
              text: 'OK',
              onClick: () => {
                handleSubmitButton();
              },
            },
          ]}
        />
      )}

      {(connectionType === AUTH_TYPE.External && currentStep === ACTIVE_STEP.uploadFilePage && uploadStatus === DOCUMENT_UPLOAD_PROGRESS.completed) ||
      (currentStep === ACTIVE_STEP.documentTableSelection && uploadStatus === DOCUMENT_UPLOAD_PROGRESS.completed) ? (
        <Button type="button" onClick={handleCloseButton}>
          終了する
        </Button>
      ) : (
        <Button variant="outlined" className="hover:bg-mercury p-3 w-28 rounded text-axaBlue font-semibold" onClick={handleCloseButton}>
          閉じる
        </Button>
      )}
    </div>
  );
};

export default CloseButton;
